import React from 'react';

// Renders **bold** / *italic* markdown the LLM sometimes emits, without raw asterisks.
export const renderEmphasis = (text) =>
  String(text || '')
    .split(/(\*\*[^*]+\*\*|\*[^*\s][^*]*\*)/g)
    .map((part, i) => {
      if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
      if (/^\*[^*]+\*$/.test(part)) return <em key={i}>{part.slice(1, -1)}</em>;
      return part.replace(/\*+/g, '');
    });

export default renderEmphasis;
